/**
 * @file   : DestinationsCmp.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 9/21/2018, 5:34:29 PM
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { getDestinationsProductList } from '../../../actions/Backend'
import { isNumber, isUndefined } from '../../../external/utilities/GeneralUtils'
import DestinationLayoutCartConf from './DestinationsLayoutCartConf'
import DestinationLayoutFacility from './DestinationsLayoutFacility'
import DestinationLayoutInfo from './DestinationsLayoutInfo'

export const TYPE_CART_CONF = 'typeCartConf'
export const TYPE_FACILITY = 'typeFacility'
export const TYPE_INFO = 'typeInfo'

class DestinationsCmp extends Component {
  constructor() {
    super()
    this.state = {
      destinationProducts: null,
      dataLatitude: 0,
      dataLongitude: 0,
    }
    this.dataLatitude = 0
    this.dataLongitude = 0
  }

  componentDidMount() {
    this.getData()
  }

  componentDidUpdate() {
    this.getData()
  }

  componentWillUnmount() {
    this.setState({
      ...this.state,
      destinationProducts: null,
    })
  }

  getData() {
    const {
      countryName,
      stateName,
      latitude,
      longitude,
      arrivalDate,
      departureDate,
      numToDisplay,
    } = this.props
    if (!isUndefined(stateName) && isNumber(latitude) && isNumber(longitude)) {
      if (this.dataLatitude !== latitude || this.dataLongitude !== longitude) {
        this.dataLatitude = latitude
        this.dataLongitude = longitude
        const destinationsSearchObj = {
          countryname: countryName,
          regionname: stateName,
          lat: latitude,
          lng: longitude,
          arv: arrivalDate,
          dep: departureDate,
        }

        if (numToDisplay !== -1) {
          destinationsSearchObj.rcs = numToDisplay
        }

        getDestinationsProductList(destinationsSearchObj, (success, data) => {
          if (success) {
            this.setState({
              ...this.state,
              destinationProducts: data,
            })
          }
        })
      }
    }
  }

  render() {
    const { destinationProducts } = this.state
    const {
      type,
      theme,
      intl,
      locationName,
      titleText,
      seeMoreText,
      seeMoreLink,
    } = this.props

    if (destinationProducts === null) {
      return null
    }

    if (type === TYPE_CART_CONF) {
      return (
        <DestinationLayoutCartConf
          theme={theme}
          intl={intl}
          destinationProducts={destinationProducts}
          locationName={locationName}
        />
      )
    } else if (type === TYPE_FACILITY) {
      return (
        <DestinationLayoutFacility
          theme={theme}
          intl={intl}
          destinationProducts={destinationProducts}
          locationName={locationName}
        />
      )
    } else if (type === TYPE_INFO) {
      return (
        <DestinationLayoutInfo
          theme={theme}
          intl={intl}
          destinationProducts={destinationProducts}
          titleText={titleText}
          seeMoreText={seeMoreText}
          seeMoreLink={seeMoreLink}
        />
      )
    }

    return null
  }

  static defaultProps = {
    countryName: 'USA',
    arrivalDate: null,
    departureDate: null,
    numToDisplay: -1,
  }

  static propTypes = {
    theme: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
    countryName: PropTypes.string,
    stateName: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    arrivalDate: PropTypes.string,
    departureDate: PropTypes.string,
    type: PropTypes.oneOf([TYPE_CART_CONF, TYPE_FACILITY, TYPE_INFO])
      .isRequired,
    locationName: PropTypes.string.isRequired,
    numToDisplay: PropTypes.number,
    titleText: PropTypes.string,
    seeMoreText: PropTypes.string,
    seeMoreLink: PropTypes.string,
  }
}

export default DestinationsCmp
